module.exports = __webpack_public_path__ + "assets/dui.35095034b3bf8869bec429ce70e0d25a.png";